<tile
  (onClick)="onClick.emit()"
  [active]="active"
  [title]="data?.name"
  [description]="data?.description"
  [media]="data?.media"
  [hoverActive]="hoverActive"
>
  <ng-content></ng-content>
</tile>
